import PropTypes from 'prop-types'
import React from 'react'
import Link from 'next/link'
import ReactSVG from 'react-svg'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import Router from 'next/router'
import { AdditionalPreloader } from 'SRC/ui/Preloader'
import { Images as RightColumnImages } from '../Images'
import { getCurrentAd } from 'SRC/modules/ads/detail/selectors'
import Lightbox from 'react-images'
import { connect } from 'react-redux'
import { getAdThumbnailUrl, getAdImageUrl } from 'SRC/modules/ads/shared/functions'

export class PhotosMobile extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    }
  }

  getVisibleImagesLength = () => this.props.ad ? this.props.ad.media.filter(item => item.visible).length : 0

  openLightbox = (index) => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: index,
      lightboxIsOpen: true
    }))
  }

  closeLightbox = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: 0,
      lightboxIsOpen: false
    }))
  }

  goToPrevious = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: this.state.currentImage === 0 ? this.getVisibleImagesLength() - 1 : this.state.currentImage - 1
    }))
  }

  goToNext = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: this.state.currentImage === this.getVisibleImagesLength() - 1 ? 0 : this.state.currentImage + 1
    }))
  }

  goToImage = (index) => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: index
    }))
  }

  handleClickImage () {
    if (this.state.currentImage === this.getVisibleImagesLength() - 1) return
    this.goToNext()
  }

  getVisibleImages = () => this.props.ad.media && Array.isArray(this.props.ad.media)
    ? this.props.ad.media.filter(item => item.visible)
    : []

  getImagesForColumn = () => {
    const visibleImages = this.getVisibleImages()
    return visibleImages.length ? visibleImages.map(item => getAdImageUrl(item)) : null
  }

  getLightBoxImages = () => {
    const visibleImages = this.getVisibleImages()
    return visibleImages.length
      ? visibleImages.map(item => ({
        src: getAdImageUrl(item),
        thumbnail: getAdThumbnailUrl({ image: item })
      }))
      : null
  }

  getCustomControls = () => {
    const { ad } = this.props
    return (
      <React.Fragment>
        <div className='image-sides image-left' key='image-left' onClick={this.goToPrevious}>
          <div className='arrow arrow-left'>
            <div className='arrow_icon arrow-left_icon' />
          </div>
        </div>

        <div className='image-sides image-right' key='image-right' onClick={this.goToNext}>
          <div className='arrow arrow-right'>
            <div className='arrow_icon arrow-right_icon' />
          </div>
        </div>

        <div className='lightbox-custom-header' key='lightbox-custom-header'>
          <span>{`${this.state.currentImage + 1}/${this.getVisibleImagesLength()}`}</span>
          <span>{ad && ad.titleCompiled ? ad.titleCompiled : ''}</span>
        </div>
        
        <span />
      </React.Fragment>
    )
  }

  render () {
    const { ad } = this.props

    const lightboxImages = this.getLightBoxImages()
    const customControls = this.getCustomControls()

    return (
      <div className='oglasi-info-photos-mobile'>
        {lightboxImages
          ? (
            <Lightbox
              currentImage={this.state.currentImage >= this.getVisibleImagesLength() - 1 ? this.getVisibleImagesLength() - 1 : this.state.currentImage}
              images={lightboxImages}
              isOpen={this.state.lightboxIsOpen}
              onClickImage={this.handleClickImage}
              onClickNext={this.goToNext}
              onClickPrev={this.goToPrevious}
              onClose={this.closeLightbox}
              onClickThumbnail={this.goToImage}
              showThumbnails
              backdropClosesModal
              customControls={[customControls]}
              showCloseButton
              theme={{
                arrow__size__medium: {
                  display: 'none'
                }
              }}
            />
          ) : null
        }

        <RightColumnImages ad={ad} onClick={this.openLightbox} length={this.getVisibleImagesLength()} />
      </div>
    )
  }
}

PhotosMobile.propTypes = {
  ad: PropTypes.shape({
    id: PropTypes.number.isRequired,
    titleCompiled: PropTypes.string.isRequired,
    media: PropTypes.arrayOf(PropTypes.shape({
      fd: PropTypes.string,
      visible: PropTypes.bool
    }))
  }).isRequired
}

const mapStateToProps = state => {
  const ad = getCurrentAd(state)

  if (ad && ad.media && Array.isArray(ad.media)) {
    ad.media.sort((a, b) => a.priority - b.priority)
  }

  return {
    ad
  }
}

export default connect(mapStateToProps)(PhotosMobile)
